// @flow
import {reportSuccess} from '@homeaway/react-error-reporter';
import type {Store} from '../../reducers';

const sanitize = (type: string) => type.replace(/[_\/]/g, ' ').toLowerCase();

export default function reportSearchSuccess(
    store: Store,
    action: {type: string}
) {
    reportSuccess({name: sanitize(action.type)});
}
